// removed by extract-text-webpack-plugin
module.exports = {"container":"style__container___q01c9","button":"style__button___wZ47J","progress":"style__progress___2G6PP","progressFill":"style__progressFill___39vZn","progressBar":"style__progressBar___38ybX","bottom":"style__bottom___VyquV","currentDuration":"style__currentDuration___3jx8z","microphone":"style__microphone___19gvD","duration":"style__duration___1zvHq","btnContainer":"style__btnContainer___2Z8_1","equalizeBg":"style__equalizeBg___1R4r-","playIcon":"style__playIcon___1sAwy","icon":"style__icon___3nVkM","activeIcon":"style__activeIcon___1YXM_","dNone":"style__dNone___3xNKN"};


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/stickers/ui/components/media-audio/style.css
// module id = 1250
// module chunks = 0